import type { TFunction } from 'i18next';
import { formatRsLocalDateTimeRangeSummary } from '../../utils/reservationBoardCalendar.util';
import styles from './ReservationBoardCalendar.module.css';

type RsBoardSelectionOutsideMonthProps = {
  startDateTime: string;
  endDateTime: string;
  onJump: () => void;
  t: TFunction;
};

/** 表示月とフォーム選択月がずれたとき、その月へ戻る導線 */
export default function RsBoardSelectionOutsideMonth({
  startDateTime,
  endDateTime,
  onJump,
  t,
}: RsBoardSelectionOutsideMonthProps) {
  const overnightPrefix = t('reservation.board.overnightPrefix', { defaultValue: '翌' });
  // 他月表示中は時刻だけではどの日か分からないので日付付き要約を使う
  const when = formatRsLocalDateTimeRangeSummary(startDateTime, endDateTime, overnightPrefix);

  return (
    <button
      type="button"
      className={styles.selectionOutsideBanner}
      onClick={onJump}
      aria-label={t('reservation.board.jumpToSelectionAria', {
        defaultValue: '選択中の枠がある月を表示',
      })}
    >
      <span className={styles.selectionOutsideLabel}>
        {t('reservation.board.jumpToSelection', {
          defaultValue: '選択中: {{when}} — その月を表示',
          when,
        })}
      </span>
    </button>
  );
}
